




























import Vue from 'vue';

import { Component, InjectReactive, Prop } from 'vue-property-decorator';

import AllCourseSearchCards from 'frontend/components/search/AllCourseSearchCards.vue';
import AllCourseSearchCardsMobile from 'frontend/components/search/AllCourseSearchCardsMobile.vue';
import { CourseData, CourseSearchGroup } from 'frontend/components/search/types';

type csgHits = CourseSearchGroup[];

@Component({
  components: {
    AllCourseSearchCards,
    AllCourseSearchCardsMobile,
  },
})
export default class AlgoliaCSGHits extends Vue {
  @InjectReactive() readonly csgHits!: csgHits;
  @InjectReactive() readonly searchQuery!: string;

  @InjectReactive() readonly csgQueryID!: string;
  @Prop(Boolean) private inHeader!: boolean;
  @Prop(Boolean) private mobile!: boolean;
  @Prop(Boolean) private isStaffUser!: boolean;

  private get key() {
    return this.$vnode.key;
  }

  private get CSG(): CourseSearchGroup {
    return this.csgHits[0];
  }

  private get courses(): CourseData[] {
    return this.CSG.search_group_courses.map((course, i) => ({
      url: course.course_url,
      image_url: course.course_image_url,
      name: course.course_name,
      id: course.course_id,
      object_id: this.CSG.objectID,
      is_published: course.course_is_published,
    }));
  }
}
